/* eslint-disable */
export default {
  title: '오디오',
  input: '입력',
  microphone: '마이크',
  autoAdjustMicLevel: '마이크 레벨 자동 조정',
  output: '출력',
  speakerSource: '스피커 소스',
  speakerVolume: '스피커 볼륨',
  ringtoneSource: '벨소리 및 알림 소스',
  ringtoneVolume: '벨소리 및 알림 볼륨',
  ringtones: '벨소리',
  noDevices: '디바이스 없음',
  off: '끄기',
  noLabel: '알 수 없는 디바이스',
  stopRecordDescription: '마이크 레벨을 확인하려면 말하세요({countDown}초).',
  stopPlaybackDescription: '레코딩 재생 중...',
  startRecordButton: '마이크 테스트',
  stopRecordButton: '레코딩 중지',
  stopPlaybackButton: '테스트 중지',
  startTestButton: '스피커 테스트',
  stopTestDescription: '샘플 사운드 재생 중...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
